import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03dafc82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar__content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__content" }, "Browse report", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-4 mt-2" }, "Date: ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-4 mt-2" }, "-", -1))
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-wrap"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Report result from : ", -1))
const _hoisted_8 = { class: "text__content mx-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__content" }, "-", -1))
const _hoisted_10 = { class: "text__content mx-2" }
const _hoisted_11 = {
  style: {"margin-left":"20px"},
  class: "text__content"
}
const _hoisted_12 = {
  style: {"margin-left":"20px"},
  class: "text__content"
}
const _hoisted_13 = {
  key: 2,
  style: {"display":"flex"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title" }, "Report result from : ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__subtitle mx-2" }, "No Data", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isBrowseReport == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_select, {
            modelValue: _ctx.config.orderType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.config.orderType) = $event)),
            name: "",
            id: "",
            style: {"margin-left":"10px","width":"150px"},
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Food delivery",
                value: 1
              }),
              _createVNode(_component_el_option, {
                label: "Messenger",
                value: 2
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            modelValue: _ctx.config.orderStatus,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.config.orderStatus) = $event)),
            name: "",
            id: "",
            style: {"margin-left":"10px","width":"150px"},
            class: "mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "All Status",
                value: 0
              }),
              _createVNode(_component_el_option, {
                label: "Completed",
                value: 6
              }),
              _createVNode(_component_el_option, {
                label: "Cancelled",
                value: 7
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _hoisted_4,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.config.startDate,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.config.startDate) = $event)),
            placeholder: "Start date",
            name: "dueDate",
            style: {"width":"150px"},
            class: "mt-2"
          }, null, 8, ["modelValue"]),
          _hoisted_5,
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.config.endDate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.endDate) = $event)),
            placeholder: "End date",
            name: "dueDate",
            style: {"width":"150px"},
            class: "mt-2"
          }, null, 8, ["modelValue"])
        ]))
      : (_ctx.originalConfig != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.moment(_ctx.originalConfig.startDate).format("YYYY/MM/DD")), 1),
            _hoisted_9,
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.moment(_ctx.originalConfig.endDate).format("YYYY/MM/DD")), 1),
            _createElementVNode("span", _hoisted_11, "Order : " + _toDisplayString(_ctx.originalConfig.orderType == 0
            ? "All"
            : _ctx.originalConfig.orderType == 1
            ? "Food delivery"
            : "Messenger"), 1),
            _createElementVNode("span", _hoisted_12, "Status : " + _toDisplayString(_ctx.originalConfig.orderStatus == 0
            ? "All"
            : _ctx.originalConfig.orderStatus == 6
            ? "Completed"
            : _ctx.originalConfig.orderStatus == 7
            ? "Cancelled"
            : "Other"), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
  ]))
}